import React from 'react';
import { SNAP_GUIDE_COLOR } from '../utils/snapUtils';

/**
 * AlignmentGuides - Renders visual snap alignment lines with distance labels
 * Displays horizontal and vertical guide lines when components align
 */
const AlignmentGuides = ({ guides, artboardWidth, artboardHeight, draggedComponent }) => {
    if (!guides || (guides.vertical.length === 0 && guides.horizontal.length === 0)) {
        return null;
    }

    const labelStyle = {
        position: 'absolute',
        background: SNAP_GUIDE_COLOR,
        color: '#fff',
        fontSize: 10,
        fontWeight: 600,
        padding: '1px 4px',
        borderRadius: 2,
        pointerEvents: 'none',
        zIndex: 1001,
        whiteSpace: 'nowrap'
    };

    return (
        <>
            {/* Vertical guides (full height lines) */}
            {guides.vertical.map((guide, index) => {
                // Support both old format (number) and new format (object)
                const x = typeof guide === 'object' ? guide.position : guide;
                const componentMidY = typeof guide === 'object'
                    ? (guide.componentTop + guide.componentBottom) / 2
                    : artboardHeight / 2;

                return (
                    <React.Fragment key={`v-${x}-${index}`}>
                        <div
                            style={{
                                position: 'absolute',
                                left: x,
                                top: 0,
                                width: 1,
                                height: artboardHeight,
                                backgroundColor: SNAP_GUIDE_COLOR,
                                pointerEvents: 'none',
                                zIndex: 1000
                            }}
                        />
                        {/* Position label */}
                        <div style={{
                            ...labelStyle,
                            left: x + 4,
                            top: Math.min(componentMidY, artboardHeight - 20)
                        }}>
                            {Math.round(x)}px
                        </div>
                    </React.Fragment>
                );
            })}

            {/* Horizontal guides (full width lines) */}
            {guides.horizontal.map((guide, index) => {
                // Support both old format (number) and new format (object)
                const y = typeof guide === 'object' ? guide.position : guide;
                const componentMidX = typeof guide === 'object'
                    ? (guide.componentLeft + guide.componentRight) / 2
                    : artboardWidth / 2;

                return (
                    <React.Fragment key={`h-${y}-${index}`}>
                        <div
                            style={{
                                position: 'absolute',
                                left: 0,
                                top: y,
                                width: artboardWidth,
                                height: 1,
                                backgroundColor: SNAP_GUIDE_COLOR,
                                pointerEvents: 'none',
                                zIndex: 1000
                            }}
                        />
                        {/* Position label */}
                        <div style={{
                            ...labelStyle,
                            left: Math.min(componentMidX, artboardWidth - 40),
                            top: y + 4
                        }}>
                            {Math.round(y)}px
                        </div>
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default AlignmentGuides;
